import { createContext, ReactElement, useCallback, useContext } from 'react';

import { AppSwitcherProps } from '../AppSwitcher.types';

type ClientPropsFunction = () => AppSwitcherProps;

export const ClientPropsContext = createContext<ClientPropsFunction>(() => {
  throw new Error('ClientPropsContext used before being provided');
});

type Props = { appSwitcherProps: AppSwitcherProps; children: ReactElement };
export function ClientPropsProvider(props: Props) {
  const { appSwitcherProps, children } = props;

  const value = useCallback(() => {
    return { ...appSwitcherProps };
  }, [appSwitcherProps]);

  return <ClientPropsContext.Provider value={value}>{children}</ClientPropsContext.Provider>;
}

export function useClientProps(): AppSwitcherProps {
  return useContext(ClientPropsContext)();
}
